<dm-drawer side="right" size="xl" [open]="isOpen()" [label]="drawerLabel" (dmOpenChange)="isOpen.set($event.detail)">
  <dm-drawer-header slot="header" [bordered]="false">
    <div class="dm-flex dm-flex-column dm-gap-16">
      <div class="dm-flex dm-gap-16">
        <dm-icon [featured]="true" theme="modern" color="gray" size="lg" name="help-circle" />
        <div class="dm-flex dm-flex-column">
          <h2 class="dm-text-lg dm-text-weight-semibold dm-color-text-primary">{{ drawerLabel }}</h2>
          <p class="dm-text-sm dm-color-text-secondary">{{ supportingText }}</p>
        </div>
      </div>
      <dm-input
        class="dm-w-full"
        inputtype="search"
        dmSize="sm"
        name="search"
        [clearable]="true"
        [disabled]="isLoading() || hasError()"
        [placeholder]="searchPlaceholder"
        [(value)]="searchTerm"
        [debounceInMs]="environmentUser.uiDebounceTime"
      >
        <dm-icon slot="leading" name="search-lg" />
      </dm-input>
    </div>
  </dm-drawer-header>

  @if (isLoading()) {
    <dm-loading-indicator type="line-simple" size="md" label="Wird geladen…" i18n-label="@@common.loading" />
  } @else if (hasError()) {
    <lp-empty-state kind="load-failed" placement="panel" [heading]="loadErrorTitle" (retryRequested)="retryLoading()" />
  } @else {
    <div class="dm-flex dm-flex-column dm-gap-32">
      @if (searchTerm().trim() && categories().length === 0) {
        <lp-empty-state
          kind="filtered"
          placement="panel"
          narrowedBy="search"
          [heading]="noResultsTitle"
          (resetRequested)="searchTerm.set('')"
        />
      }

      @for (category of categories(); track category.faqKategorieID) {
        <section class="dm-flex dm-flex-column dm-gap-16">
          <h3 class="dm-text-md dm-text-weight-medium dm-color-text-primary dm-margin-top-24">{{ category.name }}</h3>
          <dm-accordion class="lp-faq-drawer__accordion" [attr.id]="buildAccordionID(category.faqKategorieID)">
            @for (faq of category.faqs; track faq.faqID) {
              <dm-accordion-item
                class="lp-faq-drawer__item"
                [value]="buildItemID(category.faqKategorieID, faq.faqID)"
                [open]="openItemID() === buildItemID(category.faqKategorieID, faq.faqID)"
                (dmAccordionItemToggle)="onItemToggle(buildItemID(category.faqKategorieID, faq.faqID), $event.detail.open)"
              >
                <dm-accordion-trigger
                  >{{ faq.title }}
                  @if (faq.lexplusVersion) {
                    <span class="dm-color-text-quaternary">(Lexplus {{ faq.lexplusVersion }})</span>
                  }
                </dm-accordion-trigger>
                <dm-accordion-content>
                  <div class="lp-faq-drawer__content dm-flex dm-flex-column dm-gap-12">
                    @if (faq.text) {
                      <dm-richtext class="dm-text-break-words dm-text-hyphens-auto" [prose]="false" [content]="faq.text" />
                    }
                    @if (resolveHttpLink(faq.dateiUrl); as sourceUrl) {
                      <a
                        class="lp-faq-drawer__source dm-text-sm dm-text-weight-medium"
                        [href]="sourceUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ resolveDocumentName(faq.dateiName, faq.dateiUrl) ?? faq.dateiUrl }}
                      </a>
                    } @else if (faq.dateiUrl) {
                      <p class="dm-text-sm dm-color-text-secondary">{{ faq.dateiUrl }}</p>
                    }
                  </div>
                </dm-accordion-content>
              </dm-accordion-item>
            }
          </dm-accordion>
        </section>
      }
    </div>
  }

  <dm-drawer-footer slot="footer" layout="horizontal">
    <dm-button color="secondary" i18n="@@common.schliessen" (click)="isOpen.set(false)">Schliessen</dm-button>
    <dm-button color="primary" (click)="contactRequested.emit()">
      <dm-icon slot="leading" name="life-buoy-01" />
      <span i18n="@@sidebar.kontakt">Kontakt</span>
    </dm-button>
  </dm-drawer-footer>
</dm-drawer>
